import { all, fork, put, call, takeEvery } from 'redux-saga/effects';
import {
    updateOutletPrice,
    registerItem,
    registerItemBulk, // ✅ NEW
    updateItem,
    deleteItem,
    itemUpdateIsActive,
    itemUpdateDisable,
    editItemBulk,
} from '../../helpers/api';

import {
    updateOutletPriceSuccess,
    updateOutletPriceError,
    registerItemSuccess,
    registerItemError,
    registerItemBulkSuccess, // ✅ NEW
    registerItemBulkError, // ✅ NEW
    updateItemSuccess,
    updateItemError,
    deleteItemSuccess,
    deleteItemError,
    itemUpdateIsActiveSuccess,
    itemUpdateIsActiveError,
    itemUpdateDisableSuccess,
    itemUpdateDisableError,
    updateItemBulkSuccess,
    updateItemBulkError,
} from './actions';

import { MenuManagementItemActionTypes } from './constants';
import { SagaIterator } from '@redux-saga/core';

/* ======================
   Update Outlet Price
====================== */

function* updateOutletPriceSaga(action: any): SagaIterator {
    try {
        const response = yield call(updateOutletPrice, action.payload);
        yield put(updateOutletPriceSuccess(response.data.message));
    } catch (error: any) {
        yield put(updateOutletPriceError(error.message || 'Error Occured'));
    }
}

/* ======================
   Register Single Item
====================== */

function* registerItemSaga(action: any): SagaIterator {
    try {
        const response = yield call(registerItem, action.payload);
        yield put(registerItemSuccess(response.data.message));
    } catch (error: any) {
        yield put(registerItemError(error.message || 'Error Occured'));
    }
}

/* ======================
   ✅ Register BULK Items
====================== */

function* registerItemBulkSaga(action: any): SagaIterator {
    try {
        const response = yield call(registerItemBulk, action.payload);
        yield put(registerItemBulkSuccess(response.data.message));
    } catch (error: any) {
        yield put(registerItemBulkError(error.message || 'Error Occured'));
    }
}

function* updateItemBulkSaga(action: any): SagaIterator {
    try {
        const response = yield call(editItemBulk, action.payload);
        yield put(updateItemBulkSuccess(response.data.message));
    } catch (error: any) {
        yield put(updateItemBulkError(error.message || 'Error Occured'));
    }
}

/* ======================
   Update Item
====================== */

function* updateItemSaga(action: any): SagaIterator {
    try {
        const response = yield call(updateItem, action.payload);
        yield put(updateItemSuccess(response.data.message));
    } catch (error: any) {
        yield put(updateItemError(error.message || 'Error Occured'));
    }
}

/* ======================
   Delete Item
====================== */

function* deleteItemSaga(action: any): SagaIterator {
    try {
        const response = yield call(deleteItem, action.payload);
        yield put(deleteItemSuccess(response.data.message));
    } catch (error: any) {
        yield put(deleteItemError(error.message || 'Error Occured'));
    }
}

/* ======================
   Update IsActive
====================== */

function* itemUpdateIsActiveSaga(action: any): SagaIterator {
    try {
        const response = yield call(itemUpdateIsActive, action.payload);
        yield put(itemUpdateIsActiveSuccess(response.data.message));
    } catch (error: any) {
        yield put(itemUpdateIsActiveError(error.message || 'Error Occured'));
    }
}

/* ======================
   Update Disable
====================== */

function* itemUpdateDisableSaga(action: any): SagaIterator {
    try {
        const response = yield call(itemUpdateDisable, action.payload);
        yield put(itemUpdateDisableSuccess(response.data.message));
    } catch (error: any) {
        yield put(itemUpdateDisableError(error.message || 'Error Occured'));
    }
}

/* ======================
   Watchers
====================== */

function* watchUpdateOutletPrice() {
    yield takeEvery(MenuManagementItemActionTypes.UPDATE_OUTLET_PRICE, updateOutletPriceSaga);
}

function* watchRegisterItem() {
    yield takeEvery(MenuManagementItemActionTypes.REGISTER_ITEM, registerItemSaga);
}

function* watchRegisterItemBulk() {
    yield takeEvery(MenuManagementItemActionTypes.REGISTER_ITEM_BULK, registerItemBulkSaga);
}

function* watchUpdateItemBulk() {
    yield takeEvery(MenuManagementItemActionTypes.UPDATE_ITEM_BULK, updateItemBulkSaga);
}

function* watchUpdateItem() {
    yield takeEvery(MenuManagementItemActionTypes.UPDATE_ITEM, updateItemSaga);
}

function* watchDeleteItem() {
    yield takeEvery(MenuManagementItemActionTypes.DELETE_ITEM, deleteItemSaga);
}

function* watchItemUpdateIsActive() {
    yield takeEvery(MenuManagementItemActionTypes.ITEM_UPDATE_ISACTIVE, itemUpdateIsActiveSaga);
}

function* watchItemUpdateDisable() {
    yield takeEvery(MenuManagementItemActionTypes.ITEM_UPDATE_DISABLE, itemUpdateDisableSaga);
}

/* ======================
   Root Saga
====================== */

function* menuManagementItemSaga() {
    yield all([
        fork(watchUpdateOutletPrice),
        fork(watchRegisterItem),
        fork(watchRegisterItemBulk), // ✅ ADDED\
        fork(watchUpdateItemBulk),
        fork(watchUpdateItem),
        fork(watchDeleteItem),
        fork(watchItemUpdateIsActive),
        fork(watchItemUpdateDisable),
    ]);
}

export default menuManagementItemSaga;
